import { extractProperty } from "utils"

import QuoteWithImage from "./QuoteWithImage"

type Props = {
  data: any
}

function QuoteWrapper({ data }: Props) {
  const body = extractProperty(data, "body")
  const image = extractProperty(data, "image")
  return (
    <QuoteWithImage image={{ url: image, alt: "" }} texts={[body]} />
  )
}

export default QuoteWrapper
